// Sibling imports
const {
  APPEND_NOTICE,
  DISMISS_NOTICE,
  REMOVE_NOTICE
} = require('./actions')
const ToastsRecord = require('./record')

// eslint-disable-next-line complexity
function toastsReducer(state = new ToastsRecord, { type, payload }) {
  switch (type) {
    case DISMISS_NOTICE:
      return state.dismissNotice(payload.noticeId)
    case REMOVE_NOTICE:
      return state.removeNotice(payload.noticeId)
    case APPEND_NOTICE:
      return (state || new ToastsRecord).appendNotice(payload)
    default:
      return state
  }
}

module.exports = toastsReducer
